<script lang="typescript">
  import Panel from '../common/Panel.svelte';
  export let message = "Ei viestiä.";
</script>

<div>
  <h1>Virhe!</h1>
  <Panel>
    <p>{message}</p>
  </Panel>
</div>

<style>
</style>

